
import { defineComponent, onMounted, ref } from 'vue';

enum ColorEnum {
	'default',
	'primary',
	'secondary',
	'danger',
}

export default defineComponent({
	props: {
		color: {
			default: 'default',
			type: String,
		},
		checkbox: {
			default: false,
			type: Boolean,
		},
		fab: {
			default: false,
			type: Boolean,
		},
		isDisabled: {
			default: false,
			type: Boolean,
		},
	},
	setup(props) {
		const buttonColor = ref('default');

		onMounted(() => {
			if (Object.values(ColorEnum).includes(props.color)) {
				buttonColor.value = props.color;
			}
		});

		return { buttonColor };
	},
});
